import { MatchDetailsStylesSchema } from './NewMatchDetailsPage.styles';

export const matchDetailsStyles: MatchDetailsStylesSchema = {
  headerFlex: {
    flexDir: 'row',
    justify: 'space-between',
  },
  headerHeading: {
    alignItems: 'center',
    display: 'flex',
    flexDir: 'row',
    fontSize: ['md', null, null, '2xl'],
  },
  headerIconButton: {
    color: 'alpha.600',
    p: '1',
    size: 'xs',
    variant: 'link',
    _hover: {
      opacity: '.8',
    },
  },
  headerSkeletonText: {
    sx: {
      '.state-prior': { color: 'white' },
    },
  },
  headerVsBox: {
    color: 'alpha.500',
  },
  bodyStack: {
    color: 'white',
    mt: ['-1', null, '0', '-2'],
    p: ['2', null, null, '4'],
    minH: '90vh',
  },
  bodyInnerWrapper: {
    alignItems: 'center',
    display: [null, null, null, 'flex'],
    justifyContent: 'space-between',
  },
  sgmLogo: {
    color: 'alpha.500',
    h: '1.25em',
    ml: '1',
    w: 'auto',
  },
  scrollButtonGroup: {
    variant: 'filter',
    boxShadow: 'none',
    bg: 'none',
    maxH: '9',
    pos: 'relative',
  },
  toMarketButton: {
    bg: 'transparent',
    borderColor: 'gamma.400',
    color: 'white',
    _active: {
      bg: 'gamma.400',
      color: 'alpha.800',
    },
    _hover: {
      color: 'gamma.400',
    },
    _last: { mr: 2 },
  },
  loadingSkeletonText: {
    my: '4',
    spacing: '4',
    skeletonHeight: '2',
  },
  accordion: {
    display: 'flex',
    flexDir: ['column', null, null, 'row'],
    mx: '-1',
  },
  accordionStack: {
    px: '1',
    w: { lg: '50%' },
    _notFirst: {
      mt: ['2', null, null, '0'],
    },
  },
  accordionItem: {
    bg: 'white',
    border: '0',
    borderRadius: 'base',
    boxShadow:
      '0 3px 5px rgba(0, 0, 0, .2), 0 1px rgba(255, 255, 255, .15) inset',
    overflow: 'hidden',
  },
  accordionButton: {
    bgGradient: 'linear(to-b, alpha.500, gamma.500)',
    color: 'gamma.800',
    fontSize: 'xs',
    fontWeight: 'bold',
    p: '2',
    pos: 'relative',
    textAlign: 'left',
    _after: {
      borderBottomWidth: '1px',
      borderColor: 'blackAlpha.400',
      bottom: '0',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      left: '0',
      opacity: '0',
      pos: 'absolute',
      right: '0',
      transition: 'inherit',
      zIndex: '1',
    },
    _expanded: {
      _after: { opacity: '1' },
    },
  },

  marketLayoutIconFlex: {
    align: 'center',
    flex: '1',
    gap: '1',
  },
  marketLayoutTooltip: {
    fontSize: 'xs',
  },
  marketLayoutIcon: {
    color: 'gamma.800',
    fontSize: 'lg',
  },
  marketLoadingCenter: {
    boxSize: '6',
  },
  centerLoadingSpinner: {
    color: 'white',
    size: 2,
  },
  marketLayoutLoadedIcon: {
    color: 'gamma.800',
    fontSize: '2xl',
  },
  marketLayoutAccordionPanel: {
    p: '0',
  },
  cancelButton: {
    fontFamily: 'roboto',
    fontSize: 'xs',
    px: '3',
  },
  clearButton: {
    fontFamily: 'roboto',
    fontSize: 'xs',
    ml: '3',
    px: '3',
  },
  countdown: {
    color: 'white',
    sx: {
      textTransform: 'uppercase',
      '&&&.state-prior': {
        p: 0,
        lineHeight: 'initial',
      },
    },
  },
  sgmLogoV2: {
    color: 'white',
    w: '8',
    h: 'auto',
  },
  wrapperScrollSgm: { w: '100%', maxW: '100%', gap: '2', mt: '2' },
  scrollButtonGroupV2: {
    flex: 1,
    position: 'relative',
    minH: '34px',
    w: '660px',
    borderRadius: 'base',
    bg: 'transparent',
  },
  accordionItemActive: {
    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
  },
  toMarketButtonV2: {
    variant: 'unstyled',
    color: 'white',
    fontSize: 'xs',
    textTransform: 'uppercase',
    minW: 'fit-content',
    fontWeight: 'bold',
    border: 'none',
    cursor: 'pointer',
    bg: 'none',
    boxShadow: 'none',

    _active: {
      bg: 'none',
    },

    sx: {
      '&&': {
        px: 2,
        ml: 0,
      },

      '&[data-active]': {
        color: 'gamma.400',
        boxShadow: 'none',
        bg: 'none',

        _after: { display: 'none', bgImage: 'none' },
      },

      '.chakra-button__icon': {
        margin: 0,
      },
    },

    _last: { mr: 2 },
  },
  sgmBtn: {
    bgGradient: 'linear(to-b, alpha.500, gamma.500)',
    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.15)',
    color: 'gamma.800',
    sx: {
      svg: {
        color: 'gamma.800',
        fill: 'gamma.800',
      },
      '&&': {
        _active: {
          color: 'gamma.800',
          bgGradient: 'linear(to-b, alpha.500, gamma.500)',
          boxShadow: 'none',
        },
      },
    },
  },
  sgmBtnActive: {
    sx: {
      svg: {
        color: 'white',
        fill: 'white',
        textShadow: '0px 2px 4px rgba(0, 0, 0, 0.20)',
      },

      '&&': {
        border: 'none',
        bg: 'gamma.800',
        boxShadow: ' 0px 3px 0px 0px rgba(0, 0, 0, 0.40) inset',
        borderColor: 'transparent',
      },
    },

    _after: { display: 'none' },
  },
};
